module.exports = __webpack_public_path__ + "assets/icons/ic_header_info_24px.svg";